<template>
  <div class="account-transaction-table">
    <table class="table">
      <thead>
        <tr>
          <th>{{ $t("table.date") }}</th>
          <th class="is-hidden-mobile">{{ $t("table.type") }}</th>
          <th>{{ $t("table.account") }}</th>
          <th>{{ $t("table.amount") }}</th>
          <th class="is-hidden-mobile">{{ $t("table.hash") }}</th>
        </tr>
      </thead>
      <tbody v-for="transaction in transactions" :key="transaction.hash">
        <tr>
          <!-- date -->
          <td class="date">
            <a class="has-text-dark" v-bind:href="'#/tx/'+ $utils.formatHash(transaction.hash)">
              {{ $utils.formatTimestamp(transaction.timestamp) }}
            </a>
          </td>
          <td class="type is-hidden-mobile" :class="typeStyle(transaction)">
            {{ typeDesc(transaction) }} <i v-if="!isContract(transaction)" :class="arrowClass(transaction)"></i>
          </td>
          <!-- account -->
          <td class="account">
            <a class="has-text-dark" v-if="!isContract(transaction)" v-bind:href="'#/account/'+ otherAddress(transaction)">
              {{ otherAddress(transaction) }}
            </a>
            <span v-if="isContract(transaction)">
              <b-icon pack="fa" icon="file-text" type="is-primary" size="is-small"></b-icon>
              <a v-bind:href="'#/account/'+ otherAddress(transaction)">
                {{ otherAddress(transaction) }}
              </a>
            </span>
          </td>
          <!-- amount -->
          <td class="amount" :class="amountStyle(transaction)">
            <b>{{ amountSymbol(transaction) }}{{ $utils.formatAmount(transaction.value) }}</b>
          </td>
          <!-- hash -->
          <td class="hash is-hidden-mobile">
            <a class="has-text-dark" v-bind:href="'#/tx/'+ $utils.formatHash(transaction.hash)">
              {{ $utils.formatHash(transaction.hash) }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'account-transaction-table',
    computed: {
      coinName () {
        return this.$COINNAME
      }
    },
    methods: {
      isMe (t) {
        if (t.from && this.address) {
          return t.from.toLowerCase() === this.address.toLowerCase()
        } else {
          return false
        }
      },
      arrowClass (t) {
        return this.isMe(t) ? 'fa fa-arrow-circle-right' : 'fa fa-arrow-circle-left'
      },
      typeDesc (t) {
        if (t.what === 'contract_creation') {
          return this.$t('table.contract_creation')
        } else if (t.what === 'contract_invoke') {
          return this.$t('table.contract_invoke')
        }
        return this.isMe(t) ? this.$t('table.send') : this.$t('table.receive')
      },
      isContract (t) {
        return t.what !== ''
      },
      otherAddress (t) {
        const add = this.isMe(t) ? t.to : t.from
        return add
      },
      typeStyle (t) {
        if (this.isContract(t)) {
          return 'has-text-info'
        }
        return this.isMe(t) ? 'has-text-danger' : 'has-text-success'
      },
      amountStyle (t) {
        return 'has-text-dark'
        // return this.isMe(t) ? 'has-text-danger' : 'has-text-success'
      },
      amountSymbol (t) {
        return !this.isMe(t) ? '+' : '-'
      }
    },
    props: ['address', 'transactions']
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/AccountTransactionTable.vue